import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './stores/authStore';
import { Shell } from './components/layout/Shell';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { HomePage } from './pages/HomePage';
import { WalletPage } from './pages/WalletPage';
import { PackagePage } from './pages/PackagePage';
import { HierarchyPage } from './pages/HierarchyPage';
import { BonusPage } from './pages/BonusPage';
import { ProfilePage } from './pages/ProfilePage';

function RequireAuth({ children }: { children: JSX.Element }) {
  const user = useAuth((s) => s.user);
  const loading = useAuth((s) => s.loading);
  if (loading && !user) {
    return <div className="min-h-screen flex items-center justify-center text-fg-muted text-sm">Loading…</div>;
  }
  return user ? children : <Navigate to="/login" replace />;
}

export default function App() {
  const bootstrap = useAuth((s) => s.bootstrap);
  useEffect(() => { bootstrap(); }, [bootstrap]);

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />

      <Route
        path="/*"
        element={
          <RequireAuth>
            <Shell>
              <Routes>
                <Route path="/" element={<Navigate to="/home" replace />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/wallet" element={<WalletPage />} />
                <Route path="/package" element={<PackagePage />} />
                <Route path="/hierarchy" element={<HierarchyPage />} />
                <Route path="/bonus" element={<BonusPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Routes>
            </Shell>
          </RequireAuth>
        }
      />
    </Routes>
  );
}
